import React, { useState, useContext } from 'react';
import { FaPlus } from 'react-icons/fa';
import './FloatingMenu.css';
import AddClimaForm from './AddClimaForm';
import AddMaoDeObraForm from './AddMaoDeObraForm';
import AddEquipamentosForm from './AddEquipamentosForm';
import AddAtividadesForm from './AddAtividadesForm';
import AddMateriaisForm from './AddMateriaisForm';
import AddInfoGeralForm from './AddInfoGeralForm';
import AddObservacoesForm from './AddObservacoesForm';
import { useTheme } from '../../../contexts/ThemeContext';
import { toast } from 'react-hot-toast';

const FloatingMenu = ({ obraId, atualizarRegistros, diaAprovado }) => {
  const [menuAberto, setMenuAberto] = useState(false);
  const [tipoModal, setTipoModal] = useState(null);
  const { darkMode } = useTheme();

  const abrirModal = (tipo) => {
    // Verificar se o dia está aprovado
    if (diaAprovado) {
      toast.error('Não é possível adicionar itens em um dia aprovado.');
      return;
    }
    setTipoModal(tipo);
    setMenuAberto(false);
  };

  const fecharModal = () => {
    setTipoModal(null);
  };

  const adicionarNovoRegistro = (tipo, dados) => {
    atualizarRegistros(tipo, dados);
  };

  return (
    <div className={`floating-menu-container ${darkMode ? 'dark-mode' : ''}`}>
      <button 
        className={`floating-menu-button ${menuAberto ? 'aberto' : ''}`}
        onClick={() => setMenuAberto(!menuAberto)}
        disabled={diaAprovado}
        title={diaAprovado ? "Não é possível adicionar itens em um dia aprovado" : "Adicionar item"}
      >
        <FaPlus />
      </button>

      {menuAberto && (
        <div className="floating-menu-items">
          <button onClick={() => abrirModal('clima')} disabled={diaAprovado}>
            <i className="fas fa-cloud-sun"></i> Clima
          </button>
          <button onClick={() => abrirModal('maoDeObra')} disabled={diaAprovado}>
            <i className="fas fa-hard-hat"></i> Mão de Obra
          </button>
          <button onClick={() => abrirModal('equipamentos')} disabled={diaAprovado}>
            <i className="fas fa-truck"></i> Equipamentos
          </button>
          <button onClick={() => abrirModal('atividades')} disabled={diaAprovado}>
            <i className="fas fa-tasks"></i> Atividades
          </button>
          <button onClick={() => abrirModal('materiais')} disabled={diaAprovado}>
            <i className="fas fa-box"></i> Materiais
          </button>
          <button onClick={() => abrirModal('info')} disabled={diaAprovado}>
            <i className="fas fa-info-circle"></i> Informações Gerais
          </button>
          <button onClick={() => abrirModal('ocorrencia')} disabled={diaAprovado}>
            <i className="fas fa-exclamation-circle"></i> Observações/Ocorrências
          </button>
        </div>
      )}

      {tipoModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className="modal-header">
              <h2>
                {tipoModal === 'clima' && 'Adicionar Clima'}
                {tipoModal === 'maoDeObra' && 'Adicionar Mão de Obra'}
                {tipoModal === 'equipamentos' && 'Adicionar Equipamentos'}
                {tipoModal === 'atividades' && 'Adicionar Atividade'}
                {tipoModal === 'materiais' && 'Adicionar Material'}
                {tipoModal === 'info' && 'Adicionar Informações Gerais'}
                {tipoModal === 'ocorrencia' && 'Adicionar Observações/Ocorrências'}
              </h2>
              <button className="modal-close" onClick={fecharModal}>
                <i className="fas fa-times"></i>
              </button>
            </div>
            <div className="modal-body">
              {tipoModal === 'clima' && (
                <AddClimaForm 
                  obraId={obraId}
                  onClose={fecharModal}
                  onSuccess={(dados) => adicionarNovoRegistro('clima', dados)}
                />
              )}
              {tipoModal === 'maoDeObra' && (
                <AddMaoDeObraForm 
                  obraId={obraId}
                  onClose={fecharModal}
                  onSuccess={(dados) => adicionarNovoRegistro('maoDeObra', dados)}
                />
              )}
              {tipoModal === 'equipamentos' && (
                <AddEquipamentosForm 
                  obraId={obraId}
                  onClose={fecharModal}
                  onSuccess={(dados) => adicionarNovoRegistro('equipamentos', dados)}
                />
              )}
              {tipoModal === 'materiais' && (
                <AddMateriaisForm 
                  obraId={obraId}
                  onClose={fecharModal}
                  onSuccess={(dados) => adicionarNovoRegistro('materiais', dados)}
                />
              )}
              {tipoModal === 'info' && (
                <AddInfoGeralForm 
                  obraId={obraId}
                  onClose={fecharModal}
                  onSuccess={(dados) => adicionarNovoRegistro('info', dados)}
                />
              )}
              {tipoModal === 'ocorrencia' && (
                <AddObservacoesForm 
                  obraId={obraId}
                  onClose={fecharModal}
                  onSuccess={(dados) => adicionarNovoRegistro('ocorrencia', dados)}
                />
              )}
              {tipoModal === 'atividades' && (
                <AddAtividadesForm 
                  obraId={obraId}
                  onClose={fecharModal}
                  onSuccess={(dados) => adicionarNovoRegistro('atividade', dados)}
                />
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FloatingMenu; 